import { useEffect, useState } from "react";
import { APIClient, clearAuthSession, getAuthToken, getLoggedinUser } from "../../helpers/api_helper";

interface AuthValidationResponse {
  status?: boolean;
  data?: any;
}

const api = new APIClient();

const useProfile = () => {
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const validateSession = async () => {
      const userProfileSession = getLoggedinUser();
      const authToken = getAuthToken();

      if (!authToken || !userProfileSession) {
        clearAuthSession();
        if (isMounted) {
          setUserProfile(null);
          setToken(null);
          setLoading(false);
        }
        return;
      }

      try {
        const response = await api.get<AuthValidationResponse>("/api/v1/me");

        if (!isMounted) {
          return;
        }

        if (response?.status) {
          setUserProfile(userProfileSession);
          setToken(authToken);
        } else {
          clearAuthSession();
          setUserProfile(null);
          setToken(null);
        }
      } catch {
        clearAuthSession();

        if (isMounted) {
          setUserProfile(null);
          setToken(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    validateSession();

    return () => {
      isMounted = false;
    };
  }, []);


  return { userProfile, loading, token };
};

export { useProfile };
